import { FC, useEffect, useState } from 'react'

import { Formik } from 'formik'

import Box from 'app/components/design-system-components/Box'
import { getOptionAndMetadataForApplicant } from 'app/components/design-system-components/InviteToApply/FormBody'
import Modal from 'app/components/design-system-components/Modal'
import {
  formFields,
  formValidation,
} from 'app/components/design-system-components/SendNotificationToOwner/form.utils'
import { FormBody } from 'app/components/design-system-components/SendNotificationToOwner/FormBody'
import { sendDepositReceivedNoticeToOwner } from 'app/components/design-system-components/SendNotificationToOwner/http'
import * as snugNotifier from 'app/services/snugNotifier'

interface IPropertyOwner {
  email?: string
  firstName?: string
  lastName?: string
  phone?: string
}

interface IContactDetails {
  email?: string
  firstName?: string
  lastName?: string
  phone?: string
}

interface SendNotificationToPropertyOwnerProps {
  toggleModal: () => void
  teamGUID?: string
  propertyDisplayText?: string
  propertyGUID: string
  contactDetails?: IContactDetails
  enquirerHasEmail?: boolean
  applicationGUID?: string
  togglePreviousModal?: () => void
  fetchCurrentOwners?: (teamGUID: string, propetyGUID: string) => Promise<any>
}

const SendNotificationToPropertyOwnerModal: FC<SendNotificationToPropertyOwnerProps> =
  ({
    toggleModal,
    teamGUID = '',
    applicationGUID = '',
    togglePreviousModal,
    fetchCurrentOwners,
    propertyGUID,
  }) => {
    const [baseInitialValues, setBaseInitialValues] = useState<any>({
      [formFields.message]: '',
      [formFields.owners]: null,
      [formFields.contact]: null,
    })

    const [isPayloadSubmitting, setIsPayloadSubmitting] = useState(false)

    useEffect(() => {
      if (fetchCurrentOwners) {
        fetchCurrentOwners(teamGUID, propertyGUID)
          .then((result) => {
            setBaseInitialValues((prevState: Record<string, any>) => ({
              ...prevState,
              [formFields.owners]: result?.map((owner: IPropertyOwner) =>
                getOptionAndMetadataForApplicant(
                  owner?.email,
                  owner?.firstName,
                  owner?.lastName,
                  owner?.phone,
                ),
              ),
            }))
          })
          .catch((error) => {
            snugNotifier.error(error)
          })
      }
    }, [fetchCurrentOwners, propertyGUID, teamGUID])

    const onSubmitDepositReceivedToOwner = (values: any) => {
      setIsPayloadSubmitting(true)
      const recipients = values[formFields.owners].map(({ option }: any) => {
        const {
          renterEmail,
          renterFirstName,
          renterLastName,
          renterContactNumber,
        } = option
        return {
          renterEmail,
          renterFirstName,
          renterLastName,
          renterContactNumber,
        }
      })
      const payload = {
        agencyGUID: teamGUID,
        recipients: recipients,
        comment: values[formFields.message],
        applicationGUID,
      }
      sendDepositReceivedNoticeToOwner(teamGUID, payload)
        .then(() => {
          snugNotifier.success('The email was successfully sent')
          toggleModal()
          togglePreviousModal && togglePreviousModal()
        })
        .catch((err: { message?: string }) => snugNotifier.error(err?.message))
        .finally(() => {
          setIsPayloadSubmitting(false)
        })
    }

    const modalBody = (
      <Box width="100%" zIndex={999999999}>
        <Formik
          initialValues={baseInitialValues}
          onSubmit={onSubmitDepositReceivedToOwner}
          validate={formValidation}
          validateOnBlur={true}
          validateOnChange={true}
          enableReinitialize
        >
          {(props) => (
            <FormBody
              formBag={props}
              teamGUID={teamGUID}
              toggleModal={toggleModal}
              isPayloadSubmitting={isPayloadSubmitting}
            />
          )}
        </Formik>
      </Box>
    )
    return (
      <Modal
        modalBody={modalBody}
        primaryLabel={undefined}
        primaryAction={undefined}
        secondaryLabel={undefined}
        secondaryAction={undefined}
        toggleModal={toggleModal}
        customModalFooter={true}
        modalHeading="Send deposit received notice"
        modalFooter={undefined}
      />
    )
  }

export default SendNotificationToPropertyOwnerModal
